import React, { useState, useEffect, useCallback } from "react";
import {
  Row,
  Col,
  Pagination,
  Collapse,
  Form,
  Button,
  Upload,
  Input,
  message,
  Select,
  Modal,
  Table,
} from "antd";
import axios from "axios";
import PageHeader from "../Layout/PageHeader";
import NotificationFilters from "./NotificationFilters";
import { CaretRightOutlined } from "@ant-design/icons";
import { NOTIFICATION_TYPE } from "../../constants/Notification";
import { formatDateTime } from "../../helpers/date";

const Notification = () => {
  const [pagination, setPagination] = useState({ currentPage: 1, limit: 10 });
  const [notification, setNotification] = useState([]);
  const [filters, setFilters] = useState({
    title: null,
    type: null,
  });
  
  const [loading, setLoading] = useState({
    index: false,
    create: false,
  });
  const [form] = Form.useForm();

  const fetchNotification = useCallback(async () => {
    setLoading((prevLoading) => ({ ...prevLoading, index: true }));

    const params = {
      ...(filters.title !== null && { title: filters.title }),
      ...(filters.type !== null && { type: filters.type }),
      limit: pagination.limit,
      page: pagination.currentPage,
    };

    const res = await axios.get("/api/notifications", { params });

    setNotification(res.data.data);
    setPagination(res.data.pagination);
    setLoading((prevLoading) => ({ ...prevLoading, index: false }));
  }, [pagination.currentPage, pagination.limit, filters]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "link",
      dataIndex: "link",
    },
    {
      title: "Remark",
      dataIndex: "remark",
    },
  ];

  useEffect(() => {
    fetchNotification();
  }, [pagination.currentPage, pagination.limit, fetchNotification]);

  const createHandler = async (newNotification) => {
    setLoading((prevLoading) => ({ ...prevLoading, create: true }));

    try {
      await axios.post("/api/notifications", {
        ...newNotification,
      });

      form.resetFields();
      message.success("Notification created");
      fetchNotification();
    } catch (error) {
      message.error(error.response?.data.message || error.message);
    }

    setLoading((prevLoading) => ({ ...prevLoading, create: false }));
  };

  return (
    <div>
      <PageHeader
        title="Notification"
        childRoutes={[
          { path: "/notification", breadcrumbName: "Notification" },
        ]}
      />

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel
          header="Create New Notification"
          key="create-notification-section"
        >
          <Form
            form={form}
            name="new-notification-form"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            autoComplete="off"
            onFinish={createHandler}
          >
            <Form.Item label="Title" name="title" rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item label="Type" name="type" rules={[{ required: true }]}>
              <Select style={{ width: 200 }}>
                {Object.values(NOTIFICATION_TYPE).map((type) => (
                  <Select.Option value={type.key}>
                    {type.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Link" name="link">
              <Input />
            </Form.Item>

            <Form.Item
              label="Remark"
              name="remark"
            >
              <Input.TextArea rows={4} />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button loading={loading.create} type="primary" htmlType="submit">
                Create
              </Button>
            </Form.Item>
          </Form>
        </Collapse.Panel>
      </Collapse>
      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Filters" key="filters">
          <NotificationFilters
            filters={filters}
            onFiltersChange={(filters) => setFilters(filters)}
          />
        </Collapse.Panel>
      </Collapse>

      <Row justify="end">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>

      <Table
        rowKey="notificationId"
        pagination={false}
        columns={columns}
        dataSource={notification}
        loading={loading.index}
      />

      <Row justify="end">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Notification;
